// extracted by mini-css-extract-plugin
module.exports = {"container":"TestimonialsSection_container__242IN","section-title":"TestimonialsSection_section-title__32at5","slider-container":"TestimonialsSection_slider-container__2X3p6"};